<template>
  <div class="item">
    <div
      class="item-img"
      :class="{ recommend: isRecommend, isaddshow: isAddshow }"
    >
      <router-link target="_blank" :to="'/video/detail?id=' + id">
        <img v-lazy="thumb" :key="thumb" />
        <!--video play btn-->
        <div class="videoplays">
          <svg
            viewBox="298 388 16 16"
            fill="#fff"
            class="iris_ic is&#45;&#45;undefined"
          >
            <path d="M298 404v-16l16 8" />
          </svg>
        </div>
        <!--show time-->
        <span class="videotimeout">{{ duration | secondToDate }}</span>
      </router-link>
      <span class="rank1" v-if="(index + 1 + (pageIndex - 1) * 20)<4">{{ index + 1 + (pageIndex - 1) * 20 }}</span>
      <span class="rank2" v-else>{{ index + 1 + (pageIndex - 1) * 20 }}</span>
    </div>
    <div class="content">
      <div
        class="top"
        id="tops"
        @mouseover="toshow()"
        @mouseout="tohide()"
        style="
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
        "
      >
        <router-link :to="`/video/detail?id=${this.id}`" target="_blank">{{
          title
        }}</router-link>
      </div>
      <div class="tagBox">
        <p class="tags">
          <span class="tag" v-for="(item, i) in tags" :key="i">{{ item }}</span>
        </p>
        <span class="count"
          ><img
            class="countIcon"
            src="/static/video/view_icon@2x.png"
            alt=""
          />{{ count }}</span
        >
      </div>
      <router-link :to="`/peopleCenter/${userId}`" target="_blank">
        <div class="bottom">
          <img
            :src="avatar | imageUrl('/static/profile_img_default.png', 40, 40)"
          />
          <span class="nickName" v-html="nickName">{{ nickName }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "item",
  data() {
    return {
      isAddshow: false,
    };
  },
  methods: {
    toshow() {
      this.isAddshow = true;
    },
    tohide() {
      this.isAddshow = false;
    },
  },
  props: [
    "id",
    "url",
    "thumb",
    "title",
    "nickName",
    "avatar",
    "isRecommend",
    "userId",
    "duration",
    "secondToDate",
    "tags",
    "count",
    "pageIndex",
    "index",
  ],
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.item {
  /* width 3.8rem */
  flex: 1;
}

.item-img {
  /* width 3.8rem */
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  a {
    display: block;
  }

  img {
    width: 255px;
    height: 144px;
    margin: 0 auto;
    display: inherit;
  }

  &.recommend:before {
    content: '';
    display: block;
    position: absolute;
    width: 0.32rem;
    height: 0.48rem;
    /* background: url('/static/vedio/recommend-tag.png') no-repeat center center; */
    background-size: contain;
    left: 0.2rem;
    top: 0;
  }

  .rank1 {
    position: absolute;
    width: 26px;
    height: 23px;
    left: 6px;
    top: -5px;
    background: url('/static/home/top_num1-3_bg@2x.png') no-repeat;
    background-size: 100% 100%;
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 23px;
    padding-left: 4px;
    box-sizing: border-box;
  }

  .rank2 {
    position: absolute;
    width: 26px;
    height: 23px;
    left: 6px;
    top: -5px;
    background: url('/static/home/top_num4-100_bg@2x.png') no-repeat;
    background-size: 100% 100%;
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 23px;
    padding-left: 4px;
    box-sizing: border-box;
  }
}

.personalcontent .rightbar .item .item-img {
  height: 112px;

  img {
    height: 112px;
  }
}

.content {
  overflow: hidden;
  color: #333;
  position: relative;

  a {
    display: block;
    width: 100%;
  }

  .top {
    a {
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      max-height: 38px;
      margin: 10px 0 8px 0;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      color: #333;
    }
  }

  .center {
    color: #777777;
    margin-top: 0.06rem;
    font-size: 0.14rem;
  }

  .tagBox {
    position: relative;

    .tags {
      width: 200px;
      margin-bottom: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .tag {
        margin-right: 5px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
    }

    .count {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      font-weight: 400;
      color: #999999;

      .countIcon {
        width: 18px;
        height: 12px;
        vertical-align: middle;
        margin-bottom: 2px;
      }
    }
  }

  .bottom {
    font-size: 0.16rem;

    img {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 1px solid #eee;
    }
  }
}

.nickName {
  display: inline-block;
  vertical-align: middle;
  color: #999;
  line-height: 0.4rem;
  height: 0.4rem;
  font-size: 12px;
  width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content .top:hover {
  color: #141c21;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.nickName:hover {
  color: #546978;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.videoplays {
  position: absolute;
  width: 65px;
  height: 40px;
  left: 10px;
  bottom: 12px;
  border-radius: 5px;
  background-color: rgba(23, 34, 35, 0.75);
  opacity: 0;
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.videoplays svg {
  width: 18px;
  height: 18px;
  margin: 10px 0 0 23px;
}

.videotimeout {
  position: absolute;
  right: 10px;
  bottom: 12px;
  opacity: 0;
  padding: 3px 6px;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.isaddshow .videoplays, .isaddshow .videotimeout, .recommend:hover .videoplays, .recommend:hover .videotimeout, .item-img:hover .videoplays, .item-img:hover .videotimeout {
  opacity: 1;
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-transition: all 0.2s ease-in;
}

.videoplays:hover {
  background-color: #00ADEF;
  cursor: pointer;
}

.vedio-list .item-img img {
  height: 144px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotList/item.vue